import AppBar from '@material-ui/core/AppBar';
import Checkbox from '@material-ui/core/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogButtons from 'ui/dialog/Buttons';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { isValidEmail } from '../../../utils/validators';
import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

const fieldStyles = theme => ({
    dense: { marginTop: 8 },
    textField: {
        padding: 10,
    },
});
let Field = props => {
    const { classes, isValid, onChange, index, fieldName, value } = props;
    return (
        <TextField
            error={!isValid}
            className={classes.dense}
            InputProps={{
                classes: {
                    input: classes.textField,
                },
            }}
            value={value}
            fullWidth={true}
            margin="normal"
            variant="outlined"
            onChange={event => onChange(index, fieldName, event.target.value)}
        />
    );
};

Field = withStyles(fieldStyles)(Field);

let Row = props => {
    const {
        index,
        onChange,
        onDelete,
        first_name,
        last_name,
        email,
        admin,
        hideAdmin,
    } = props;

    const isValid = (index, field) => {
        return props.usersErrors[index]
            ? props.usersErrors[index][field]
            : true;
    };

    return (
        <TableRow>
            <TableCell style={{ width: '4%' }}>{index + 1}</TableCell>
            <TableCell style={{ width: '22%' }}>
                <Field
                    index={index}
                    fieldName="first_name"
                    value={first_name}
                    onChange={onChange}
                    isValid={isValid(index, 'first_name')}
                />
            </TableCell>
            <TableCell style={{ width: '22%' }}>
                <Field
                    index={index}
                    fieldName="last_name"
                    value={last_name}
                    onChange={onChange}
                    isValid={isValid(index, 'last_name')}
                />
            </TableCell>
            <TableCell style={{ width: '40%' }}>
                <Field
                    index={index}
                    fieldName="email"
                    value={email}
                    onChange={onChange}
                    isValid={isValid(index, 'email')}
                />
            </TableCell>
            {!hideAdmin && (
                <TableCell style={{ width: '6%' }}>
                    <Checkbox
                        padding="checkbox"
                        checked={admin}
                        onChange={event =>
                            onChange(index, 'admin', event.target.checked)
                        }
                        value="admin"
                        color="secondary"
                    />
                </TableCell>
            )}
            <TableCell style={{ width: '6%' }}>
                <IconButton onClick={event => onDelete(index)}>
                    <ClearIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

const styles = theme => ({
    appBar: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.secondary.main,
    },
    stat: {
        paddingRight: 0,
        marginLeft: theme.spacing(10),
        fontWeight: 500,
    },
    dialog: { height: 600, maxWidth: 900 },
    dialogToolbar: { padding: 0, flexDirection: 'row-reverse' },

    tableWrapper: {
        minHeight: '380px',
        maxHeight: '380px',
        overflow: 'auto',
    },
    tableBody: {
        '& tr td': {
            padding: '0 3px',
        },
    },
});

const cleanEmails = emailText => {
    return emailText
        .trim()
        .split(',')
        .map(email => email.trim())
        .filter((email, index, self) => email && self.indexOf(email) === index);
};
const validateEmails = emails => {
    const valid = emails.every(isValidEmail);
    return valid ? null : 'The data is not formatted correctly.';
};

const validateUsersInfo = (users, currentUsersEmails) => {
    let globalErrorMessage = '';
    const count = names =>
        names.reduce((a, b) => Object.assign(a, { [b]: (a[b] || 0) + 1 }), {});

    const duplicates = dict => Object.keys(dict).filter(a => dict[a] > 1);

    const emails = users.map(({ email }) => email.trim());

    let duplicatedEmails = duplicates(count(emails));

    // duplication in entered data
    if (duplicatedEmails.length > 0) {
        globalErrorMessage = 'There are duplicate emails';
    }

    // duplication with existing email
    if (duplicatedEmails.length === 0) {
        duplicatedEmails = currentUsersEmails.filter(email =>
            emails.includes(email)
        );
        globalErrorMessage =
            duplicatedEmails.length > 0
                ? 'This email address was already invited'
                : '';
    }

    const areFieldsValid = users.map(user => {
        return {
            first_name: Boolean(user.first_name),
            last_name: Boolean(user.last_name),
            email:
                isValidEmail(user.email) &&
                !duplicatedEmails.includes(user.email.trim()),
        };
    });

    const allValid = areFieldsValid.flatMap(item => Object.values(item));

    const valid = !allValid.some(fieldValid => !fieldValid);

    return [valid, areFieldsValid, globalErrorMessage];
};

const MultipleUsersForm = props => {
    const {
        classes,
        open,
        onOk,
        onCancel,
        availableLicenses,
        currentUsersEmails,
        formErrors,
        hideAdmin,
    } = props;

    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [emails, setEmails] = useState('');
    const [users, setUsers] = useState([]);
    const [erroMessage, setErrorMessage] = useState(null);
    const [usersErrors, setUsersErrors] = useState([]);

    const onChange = (index, field, value) => {
        const nu = users.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );

        setUsers(nu);
    };

    const onDelete = index => setUsers(users.filter((_, i) => i !== index));
    const onNextButton = () => {
        const cleaned = cleanEmails(emails);
        const error = validateEmails(cleaned);

        if (error === null) {
            const usersData = cleaned.map(email => ({
                first_name: '',
                last_name: '',
                email: email.trim(),
                admin: false,
            }));
            setUsers(usersData);
            setTab(1);
        }
        setErrorMessage(error);
    };
    const onOkButton = async () => {
        const [valid, errors, errorMessage] = validateUsersInfo(
            users,
            currentUsersEmails
        );
        setUsersErrors(errors);
        setErrorMessage(errorMessage);
        if (valid) {
            setLoading(true);
            await onOk(users);
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            fullWidth={true}
            maxWidth="md"
            classes={{ paperScrollPaper: classes.dialog }}
        >
            <DialogTitle>Add Users</DialogTitle>
            <DialogContent>
                <AppBar
                    position="static"
                    className={classes.appBar}
                    elevation={0}
                >
                    <Toolbar className={classes.dialogToolbar}>
                        <Typography className={classes.stat}>
                            Available Licenses: {availableLicenses}
                        </Typography>
                    </Toolbar>
                </AppBar>
                {tab === 0 && (
                    <>
                        <Typography variant="subtitle2">
                            Emails Enter the email address for each user
                            separated by a comma.
                        </Typography>
                        <TextField
                            multiline
                            required
                            fullWidth={true}
                            margin="normal"
                            variant="outlined"
                            rows={15}
                            value={emails}
                            onChange={event => {
                                setEmails(event.target.value);
                            }}
                        />
                    </>
                )}
                {tab === 1 && (
                    <>
                        <div className={classes.tableWrapper}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                            #
                                        </TableCell>
                                        <TableCell padding="checkbox">
                                            First Name
                                        </TableCell>
                                        <TableCell padding="checkbox">
                                            Last Name
                                        </TableCell>
                                        <TableCell padding="checkbox">
                                            Email Address
                                        </TableCell>
                                        {!hideAdmin && (
                                            <TableCell padding="checkbox">
                                                Admin
                                            </TableCell>
                                        )}
                                        <TableCell padding="checkbox">
                                            &nbsp;
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.tableBody}>
                                    {users.map((user, index) => {
                                        return (
                                            <Row
                                                key={`r-${index}`}
                                                index={index}
                                                onChange={onChange}
                                                onDelete={onDelete}
                                                usersErrors={usersErrors}
                                                hideAdmin={hideAdmin}
                                                {...user}
                                            />
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                {formErrors && (
                    <Typography color="error">{formErrors}</Typography>
                )}
                {erroMessage && (
                    <Typography color="error">{erroMessage}</Typography>
                )}
                <DialogButtons>
                    {onCancel && (
                        <DialogButtons.Secondary
                            onClick={onCancel}
                            label="Cancel"
                            disabled={loading}
                        />
                    )}
                    {tab === 0 ? (
                        <DialogButtons.Primary
                            label="Next"
                            variant="contained"
                            onClick={onNextButton}
                            autoFocus
                        />
                    ) : (
                        <DialogButtons.Primary
                            label="OK"
                            variant="contained"
                            onClick={onOkButton}
                            autoFocus
                            loading={loading}
                        />
                    )}
                </DialogButtons>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(MultipleUsersForm);
